import { render } from "./TownZoningPlanMap.vue?vue&type=template&id=a020850c&ts=true"
import script from "./TownZoningPlanMap.vue?vue&type=script&lang=ts"
export * from "./TownZoningPlanMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__